module.exports = __webpack_public_path__ + "img/sensory-perception.3ed0927e.svg";